import { render, staticRenderFns, recyclableRender, components } from "./tn-load-more.vue?vue&type=template&id=56cc019c&scoped=true&"
var renderjs
import script from "./tn-load-more.vue?vue&type=script&lang=js&"
export * from "./tn-load-more.vue?vue&type=script&lang=js&"
import style0 from "./tn-load-more.vue?vue&type=style&index=0&id=56cc019c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc019c",
  null,
  false,
  components,
  renderjs
)

export default component.exports